import { CustomerContact } from '../customer-contact';

export interface SalesOrderEmailContacts {
  id: string;
  emailConfirmation: boolean;
  emailInvoice: boolean;
  customerConfirmationEmailAddress: string;
  customerInvoiceEmailAddress: string;
  salesOrderContactEmailAddress: string;
  customerContacts: CustomerContact[];
}
